module.exports = __webpack_public_path__ + "aba7da01.svg";